import { render, staticRenderFns } from "./highlightIncorrectWords.vue?vue&type=template&id=fa162f0e&scoped=true&"
import script from "./highlightIncorrectWords.vue?vue&type=script&lang=js&"
export * from "./highlightIncorrectWords.vue?vue&type=script&lang=js&"
import style0 from "./highlightIncorrectWords.vue?vue&type=style&index=0&id=fa162f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa162f0e",
  null
  
)

export default component.exports